import React from 'react';
import Loader from 'react-loader-spinner';
/*  * type options *
 * Audio, Ball-Triangle, Bars, Circles, Grid, Hearts
 * Oval, Puff, Rings, TailSpin, ThreeDots
*/
import { usePromiseTracker } from 'react-promise-tracker';

function LoadingIndicator(props) {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress &&
    <div className='loading-indicator'>
      <span style={{color: "blue"}}>{props.loading_message}</span>&nbsp;
      <Loader type="ThreeDots" color="#2BAD60" height="20" width="70" />
      <style jsx='true'>
      {`
        .loading-indicator {
          display: flex;
        }
      `}
      </style>
    </div>
  );
}

export default LoadingIndicator;
